module.exports = __webpack_public_path__ + "static/media/V.524cdc8f.jpg";